<div class="d-flex align-items-center">
  @for (star of starsAmountIndicator; track star) {
    <button type="button" class="p-2 btn btn-link" (click)="selectStar(star)">
      <svg-icon  class="star"
        [ngClass]="{'selected': value >= star}"
      [src]="'assets/image/icon/star.svg'"></svg-icon>
    </button>
  }
</div>
